// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent, flexParentCenterCrossAxis } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
// Constants
export const MenuOffset = 3;
/**
 * Base dropdown styles for the menu button
 */ const baseDropdownStyle = {
    width: "100%",
    paddingRight: tokens.spacingHorizontalMNudge,
    justifyContent: "space-between",
    "& .fui-MenuButton__menuIcon": {
        width: "auto",
        height: "auto",
        color: tokens.colorNeutralForeground3
    }
};
/**
 * Base wrapper styles
 */ const baseWrapperStyle = {
    position: "relative",
    marginBottom: tokens.spacingVerticalXXS,
    "::after": {
        content: '""',
        position: "absolute",
        left: "-1px",
        right: "-1px",
        bottom: "-1px",
        backgroundColor: tokens.colorBrandStroke1,
        borderBottomLeftRadius: tokens.borderRadiusMedium,
        borderBottomRightRadius: tokens.borderRadiusMedium,
        height: tokens.strokeWidthThickest,
        transform: "scaleX(0)",
        transitionProperty: "transform",
        transitionDuration: tokens.durationUltraFast,
        transitionTimingFunction: tokens.curveAccelerateMid,
        borderBottom: `${tokens.strokeWidthThick} solid ${tokens.colorCompoundBrandStroke}`,
        clipPath: "inset(calc(100% - 1.5px) 0px 0px)"
    }
};
/**
 * Styles for SensitivityLabelPicker component
 */ export const useStyles = makeStyles({
    root: {
        fontSize: tokens.fontSizeBase200
    },
    sensitivityTitle: {
        ...flexParent(),
        ...flexParentCenterCrossAxis,
        justifyContent: "flex-start",
        fontWeight: tokens.fontWeightSemibold,
        gap: tokens.spacingHorizontalSNudge,
        marginBottom: tokens.spacingVerticalXXS,
        paddingTop: tokens.spacingVerticalXXS,
        paddingBottom: tokens.spacingVerticalXXS
    },
    learnMore: {
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightSemibold,
        marginLeft: "auto",
        textDecoration: "none"
    },
    readOnlyMessage: {
        marginTop: tokens.spacingVerticalM,
        color: tokens.colorNeutralForeground2
    },
    readOnlyValue: {
        color: tokens.colorNeutralForeground1,
        paddingTop: tokens.spacingVerticalXXS,
        paddingBottom: tokens.spacingVerticalXXS
    },
    dropdownWrapper: {
        ...baseWrapperStyle,
        // Suppress the wrapper's ::after focus overlay; the inner MenuButton's
        // borderBottomColor handles the expanded-state underline so it follows
        // the rounded corners correctly.
        "::after": {
            content: "unset"
        }
    },
    dropdown: {
        ...baseDropdownStyle,
        color: tokens.colorNeutralForeground1,
        border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
        borderRadius: tokens.borderRadiusXLarge,
        ":hover, :active": {
            color: tokens.colorNeutralForeground1,
            borderTopColor: tokens.colorNeutralStroke1Hover,
            borderLeftColor: tokens.colorNeutralStroke1Hover,
            borderRightColor: tokens.colorNeutralStroke1Hover,
            borderBottomColor: tokens.colorNeutralStrokeAccessible
        },
        ":hover:active": {
            color: tokens.colorNeutralForeground1,
            borderTopColor: tokens.colorNeutralStroke1Pressed,
            borderLeftColor: tokens.colorNeutralStroke1Pressed,
            borderRightColor: tokens.colorNeutralStroke1Pressed,
            borderBottomColor: tokens.colorNeutralStrokeAccessible
        },
        "&[aria-expanded='true'], &[aria-expanded='true']:hover": {
            borderTopColor: tokens.colorNeutralStroke1Selected,
            borderLeftColor: tokens.colorNeutralStroke1Selected,
            borderRightColor: tokens.colorNeutralStroke1Selected,
            borderBottomColor: tokens.colorCompoundBrandStroke
        }
    },
    placeholder: {
        color: tokens.colorNeutralForeground4,
        fontWeight: tokens.fontWeightRegular
    }
});
